<template>
  <header id="header">
    <div class="inner_static">
      <a id="btn_top" @click="btnTopClick()"></a>
    </div>
  </header>
</template>

<script>

export default {
  props: {
    headerType: {
      type: Number,
      default: 0
    }
  },
  methods: {
    btnTopClick: function () {
      if (this.headerType === 0) {
        this.$router.push('/kagull/login')
      } else {
        this.$router.push('/kagull/top')
      }
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/common/HomeIconHeader.vue